import React from 'react';
import { HeroSection, HowItWorks } from '../../components/layouts/Home';

function HomeView() {
  return (
    <div>
      <HeroSection />
      <HowItWorks />
    </div>
  );
}

export default HomeView;
